import service from '@/services/superaccess'

const credential = {
  state: {
    credential_modal: false
  },
  mutations: {
    updateStatusCredentialModal (state, status) {
      state.credential_modal = status
    }
  },
  getters: {
    getStatusCredentialModal (context) {
      return context.credential_modal
    }
  },
  actions: {
    setStatusCredentialModal (context, payload) {
      context.commit('updateStatusCredentialModal', payload)
    },
    retrieveCredentials (context, payload) {
      return service.post('/api/credentials/list', context)
    },
    saveCredential (context, payload) {
      return service.post('/api/credentials/create', context, { credential: payload })
    },
    changeCredentialStatus (context, payload) {
      return service.patch('/api/credentials/inactive', context, payload)
    },
    modifyCredential (context, payload) {
      return service.patch('/api/credentials/modify', context, { credential: payload })
    },
    showPersonCredential (context, payload) {
      return service.post('/api/credentials/list_by_person', context, { data: payload })
    },
    showFacilityCode (context, payload) {
      return service.post('/api/credentials/showFacilityCode', context)
    }
  }
}

export default credential



// WEBPACK FOOTER //
// app/javascript/src/store/credential.js